// MyExtension.js
// this loads the Autodesk class
const {Autodesk} = window;
class MyExtension extends Autodesk.Viewing.Extension {
    constructor(viewer, options) {
        super(viewer, options);
        this.viewer = viewer;
    }
    load() {
        console.log('MyExtension 18 loaded');
        alert('MyExtension 18 loaded!');
        // … additional setup …
        return true;
    }
    unload() {
        console.log('MyExtension 18 unloaded');
        alert('MyExtension 18 unloaded!');
        return true;
    }
}
// Autodesk.Viewing.theExtensionManager.registerExtension('MyExtension', MyExtension);
// It is important to have the extension file not in the public folder, a change in the file would reload the whole app
window.MyExtension = MyExtension; // Expose globally
